// כל ה-namespaces, בשתי השפות. קובץ לכל אזור במערכת (features/<name>) ועוד
// common לרכיבים המשותפים. העברית היא המקור לטיפוסים (src/i18next.d.ts); האנגלית
// חייבת אותם מפתחות — נבדק ב-locales.test.ts.

import he_common from './he/common.json';
import he_admin from './he/admin.json';
import he_assistant from './he/assistant.json';
import he_auth from './he/auth.json';
import he_billing from './he/billing.json';
import he_contracts from './he/contracts.json';
import he_customers from './he/customers.json';
import he_dashboard from './he/dashboard.json';
import he_inventory from './he/inventory.json';
import he_invoices from './he/invoices.json';
import he_jobTypes from './he/job-types.json';
import he_learning from './he/learning.json';
import he_maintenance from './he/maintenance.json';
import he_onboarding from './he/onboarding.json';
import he_priceList from './he/price-list.json';
import he_processes from './he/processes.json';
import he_public from './he/public.json';
import he_purchasing from './he/purchasing.json';
import he_quotes from './he/quotes.json';
import he_reports from './he/reports.json';
import he_schedule from './he/schedule.json';
import he_settings from './he/settings.json';
import he_suppliers from './he/suppliers.json';
import he_tasks from './he/tasks.json';
import he_workflows from './he/workflows.json';
import en_common from './en/common.json';
import en_admin from './en/admin.json';
import en_assistant from './en/assistant.json';
import en_auth from './en/auth.json';
import en_billing from './en/billing.json';
import en_contracts from './en/contracts.json';
import en_customers from './en/customers.json';
import en_dashboard from './en/dashboard.json';
import en_inventory from './en/inventory.json';
import en_invoices from './en/invoices.json';
import en_jobTypes from './en/job-types.json';
import en_learning from './en/learning.json';
import en_maintenance from './en/maintenance.json';
import en_onboarding from './en/onboarding.json';
import en_priceList from './en/price-list.json';
import en_processes from './en/processes.json';
import en_public from './en/public.json';
import en_purchasing from './en/purchasing.json';
import en_quotes from './en/quotes.json';
import en_reports from './en/reports.json';
import en_schedule from './en/schedule.json';
import en_settings from './en/settings.json';
import en_suppliers from './en/suppliers.json';
import en_tasks from './en/tasks.json';
import en_workflows from './en/workflows.json';

export const he = {
  'common': he_common,
  'admin': he_admin,
  'assistant': he_assistant,
  'auth': he_auth,
  'billing': he_billing,
  'contracts': he_contracts,
  'customers': he_customers,
  'dashboard': he_dashboard,
  'inventory': he_inventory,
  'invoices': he_invoices,
  'job-types': he_jobTypes,
  'learning': he_learning,
  'maintenance': he_maintenance,
  'onboarding': he_onboarding,
  'price-list': he_priceList,
  'processes': he_processes,
  'public': he_public,
  'purchasing': he_purchasing,
  'quotes': he_quotes,
  'reports': he_reports,
  'schedule': he_schedule,
  'settings': he_settings,
  'suppliers': he_suppliers,
  'tasks': he_tasks,
  'workflows': he_workflows,
} as const;
export const en = {
  'common': en_common,
  'admin': en_admin,
  'assistant': en_assistant,
  'auth': en_auth,
  'billing': en_billing,
  'contracts': en_contracts,
  'customers': en_customers,
  'dashboard': en_dashboard,
  'inventory': en_inventory,
  'invoices': en_invoices,
  'job-types': en_jobTypes,
  'learning': en_learning,
  'maintenance': en_maintenance,
  'onboarding': en_onboarding,
  'price-list': en_priceList,
  'processes': en_processes,
  'public': en_public,
  'purchasing': en_purchasing,
  'quotes': en_quotes,
  'reports': en_reports,
  'schedule': en_schedule,
  'settings': en_settings,
  'suppliers': en_suppliers,
  'tasks': en_tasks,
  'workflows': en_workflows,
} as const;

export const NAMESPACES = Object.keys(he) as Array<keyof typeof he>;
